import React from 'react'

import AngleRightSVG from '@Assets/SVG/AngleRight'
import { DrawerPageSync } from '@Components/Drawer/Page'
import { DrawerDataFragment, PagePresentation } from '@Generated/graphql'

import styles from './styles.module.scss'

export const ProductDisplayDrawerTrigger = ({
  children,
  onOpenChange,
  sourceID,
  title,
  triggerTitle,
}: {
  children?: React.ReactNode
  onOpenChange?: React.ComponentProps<typeof DrawerPageSync>['onOpenChange']
  sourceID: string
  title: React.ReactNode
  triggerTitle?: React.ReactNode
}) => (
  <div className={styles.wrapper}>
    <DrawerPageSync
      onOpenChange={onOpenChange}
      page={{
        id: sourceID,
        title,
        type: 'custom',
      } as DrawerDataFragment}
      presentation={PagePresentation.Sidebar}
      sourceID={sourceID}
      triggerRender={props => (
        <button {...props} className={styles.trigger} type="button">
          {triggerTitle || title}
          <AngleRightSVG className={styles.icon} />
        </button>
      )}
    >
      {children}
    </DrawerPageSync>
  </div>

)

